import React from 'react';

const Footer: React.FC = () => {
  return (
    <footer className='bg-gray-900 text-gray-300 py-8 px-4 mt-auto'>
      <div className='max-w-6xl mx-auto text-center'>
        <p className='text-sm'>
          © 2024 CodedGhostMinis. All rights reserved. | Premium 3D printed
          miniatures for tabletop gaming.
        </p>
      </div>
    </footer>
  );
};

export default Footer;
